import request from '@/utils/request';
import { stringify } from 'qs';

export async function page(payload) {
  return request(`/iwms-wms/wms/tareschemeconfig/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function saveConfig(payload) {
  return request(`/iwms-wms/wms/tareschemeconfig`, {
    method: 'POST',
    body: payload,
  });
}

export async function setDefault(payload) {
  return request(`/iwms-wms/wms/tareschemeconfig/${payload.uuid}`, {
    method: 'POST',
  });
}

export async function remove(payload) {
  return request(`/iwms-wms/wms/tareschemeconfig/${payload.uuid}`, {
    method: 'DELETE',
  });
}

export async function getConfig(payload) {
  return request(`/iwms-wms/wms/tareschemeconfig/${payload.uuid}/get`, {
    method: 'GET',
  });
}

export async function getConfigList(payload) {
  return request(`/iwms-wms/wms/tareschemeconfig/getByDcUuid?dcUuid=${payload.dcUuid}`, {
    method: 'GET',
  });
}
